"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { makeStyles } from "../theming/index.js";
const useStyles = makeStyles()((theme, active) => {
    const { colors, outline, size } = theme;
    return {
        icon: {
            "pointerEvents": active ? "auto" : "none",
            "outline": 0,
            "&:focus, &:active": {
                outline: 0,
                boxShadow: outline(colors.primary),
                borderRadius: size(4),
            },
        },
    };
});
export function ActionIcon(_a) {
    var { active, className, icon: Icon, onAction } = _a, props = __rest(_a, ["active", "className", "icon", "onAction"]);
    const { classes, cx } = useStyles(active);
    return (_jsx(Icon, Object.assign({}, props, { className: cx(classes.icon, className), role: active ? "button" : "none", tabIndex: active ? 0 : -1, onClick: onAction, onKeyDown: e => {
            if (e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault();
                e.stopPropagation();
                onAction();
            }
        } })));
}
export default ActionIcon;
//# sourceMappingURL=action-icon.js.map